import React from 'react'
import { useState } from 'react';

import { Footer } from './components/footer';
import { Hotkey } from './types/hotkey';
import { Header } from './components/header';
import { ScoreSection } from './components/score_section';
import { OptionSection } from './components/option_section';
import { AdviceText } from './components/advice_text';
import { PresetSection } from './components/preset_section';
import { useCursor } from './hooks/use_cursor';
import { useKeyProcessor } from './hooks/use_key_processor';
import { Controls, ControlSymbol, KeySymbol, Symbol, Symbols } from './types/symbol';
import { usePractice } from './hooks/use_practice';
import { Content } from './components/content';
import { FormattedText } from './components/formatted_text';
import { Instructions } from './components/instructions';
import { TextBox } from './components/text_box';

function App() {
	const [text, setText] = useState<Array<string>>([])
	const [cursor, showCursor] = useCursor()
	const [showInstructions, setShowInstructions] = useState(true)

	const [
		output_text, 
		score, 
		highscore, 
		startPractice, 
		isComplete
	] = usePractice(text)

	const start = () => {
		if (!showInstructions) {
			startPractice()
			setText([])
		}
	}

	const paste = (data: string) => {
		const regex = /[ ]{4}/ig;
		const cleaned_data = data
			.replace(/[\u2018\u2019]/g, "'")
			.replace(/[\u201C\u201D]/g, '"')
			.replaceAll(regex, '\t')
		setText(cleaned_data.split(''))
	}

	const paste_from_clipboard = () => {
		if (navigator.clipboard.readText) {
			navigator.clipboard.readText().then(paste)
		}
	}

	const clear = () => {
		setText([])
		setShowInstructions(false)
	}

	const receive_key = (key: string) => {
		isComplete(key)
		setText([...text, key])
	}

	const delete_key = () => {
		if (text.length > 0) {
			setText(text.slice(0, text.length - 1))
		}
	}
	
	let hotkeys: Array<Hotkey> = [
		{ metas: ['ctrl'], key: 'v', action: paste_from_clipboard },
		{ metas: ['ctrl'], key: 'r', action: start },
		{ metas: ['ctrl'], key: 'c', action: clear },
	]

	useKeyProcessor(hotkeys, (symbol: Symbol) => {
		switch (symbol.type) {
			case Symbols.Key:
				const key_symbol = symbol as KeySymbol
				receive_key(key_symbol.key.toString())
				break
			case Symbols.Control:
				const control = symbol as ControlSymbol
				switch (control.control) {
					case Controls.Delete:
						delete_key()
						break
				}
				break
		}
		showCursor()
	})

	return (
		<div>
			<Header />
			<Content>
				<ScoreSection
					score={score}
					highscore={highscore}
				/>
				<PresetSection callback={(data: string) => {
					setText(data.split(''))
				}} />
				<TextBox onPaste={paste}>
					{showInstructions ? (
						<Instructions />
					) : (
						<FormattedText text={output_text} cursor={cursor} />
					)}
				</TextBox>
				<AdviceText />
				<OptionSection
					start={start}
					clear={clear}
				/>
			</Content>
			<Footer />
		</div>
	);
}

export default App;
